<template>
  <div>
    <div class="custom_2">
        <div class="custom2_title">{{newsObj.title}}</div>
        <div class="custom2_describe_text">{{newsObj.describeText}}</div>
        <div class="custom2_reason">原因：{{newsObj.reason}}</div>
        <div class="custom2_again" @click="again">重新提交</div>
    </div>
   
  </div>
</template>
<script>
export default {
  props: {
    payload: {
      type: Object,
      required: true
    }

  },
    data(){
        return {
            newsObj :{},
            imgList:[]
        }
    },
    methods:{
        again(){
            this.$bus.$emit("againInquiry")
        },



    },
    mounted(){
      // console.log(this.payload)
      this.newsObj = JSON.parse(this.payload.data).data||{}
    //  console.log(this.newsObj)
       

        
    }

};
</script>
<style lang="scss" scoped>
.custom_2 {
    .custom2_title{
        font-weight: bold;
        margin-bottom: 10px;
    }
    .custom2_describe_text{

    }
    .custom2_reason{
        color: red;
    }
    .custom2_again{
        color: #FEA57A;
        text-align: center;
        border-top: 1px solid #e2e2e2;
        margin-top: 10px;
        padding-top: 5px;
        cursor: pointer;
    }
}
</style>